<template>
  <div class="industry_case">
    <div class="banner">
        <h1>Industry Case</h1>
         <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
            <button @click="goToContact(3)" class="inner-ri">Contact us</button>
         </div>
    </div>
    <div class="case_main">
      <div class="case_item" v-for="item in caseList" :key="item.id" @click="goto_casedetail(item.id)">
        <div class="case_img">
          <img :src="item.thumbnail || item.banner" alt="">
        </div>
        <h4 class="case_name">{{ item.name }}</h4>
      </div>
    </div>
  </div>
</template>

<script setup name="WorkCaseEN">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
import { getCasePage } from '@/api/case'
const caseList = ref([]);
onMounted(() => {
  window.scrollTo(0, 0);
  caserender()
})
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
async function caserender() {
  const params = {
    appId: window.location.pathname.startsWith('/en') ? 2 : 1,
    objectType: 'case',
    current: 1,
    size: 100
  }
  const res = await getCasePage(params)
  caseList.value = res.data.records
}
function goto_casedetail(id) {
  router.push(`/en/casedetail?id=${id}`)
}
</script>

<style scoped>
.industry_case {
  width: 100%;
  height: 100%;
}
.banner {
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 12em;
  color: white;
  background-color: #ddd;
  margin-bottom: 8em;
  background-image: url('https://official-web-static.womucloud.com/bigBanner/pc/case.jpg');
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner_btn {
  margin-left: 18%;
  font-size: 0.8em;
}
.inner-le, .inner-ri {
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 1.5em auto;
}
.inner-le {
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri {
  background-color: skyblue;
  color: white;
}
.banner h1 {
  width: 65%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 1em;
  margin-left: 18%;
}
.case_main {
  width: 60%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 2em;
}
.case_item {
  width: calc((100% - 4em) / 3);
  cursor: pointer;
  overflow: hidden;
}
.case_item .case_img {
  width: 100%;
  height: 10em;
  background-color: #ddd;
  overflow: hidden;
}
.case_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}
.case_item:hover .case_img img {
  transform: scale(1.05);
}
.case_item .case_name {
  margin-top: 0.8em;
  font-size: 1.1em;
  font-weight: 400;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.case_item .case_name:hover {
  color: #FF6B02;
}
@media (max-width: 1024px) {
  .banner {
    height: 12em;
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/case.jpg');
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1 {
    font-size: 1.5em;
    margin-top: 2.5em;
  }
  .inner_btn {
    margin-left: 0;
  }
  .inner-le, .inner-ri {
    font-size: 0.8em;
    height: 2.5em;
    margin-bottom: 2em;
  }
  .case_main {
    width: 90%;
    gap: 1em;
  }
  .case_item {
    width: calc((100% - 2em) / 3);
  }
  .case_item .case_img {
    height: 6em;
  }
  .case_item .case_name {
    font-size: 0.8em;
  }
}
</style>
